/// <reference path="../../../../components/common/payroll.service.ts" />
/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../../../components/controls/presets/presets-list.ts" />

module Meevo.Plugins.Reports {
    import PresetStatus = Meevo.Components.Controls.PresetStatus;

    interface IParameter {
        clrType: string;
        controlId: number;
        dbType: string;
        name: string;
        sequence: number;
    }

    interface IValue {
        displayName: string;
        id: number;
        locationId: number;
        languageId: number;
        sortOrder: number;
        value: string;
    }

    interface IOptions {
        displayName: string;
        id: number;
        parameters: IParameter[];
        reportControlEnumType: number;
        securityAttribId: number;
        sequence: number;
        values: IValue[];
    }

    interface ICurrentValidationJson {
        MaxDateRange: number;
        MinDate?: number;
        RunReportFor?: string;
    }

    interface IDB015Model {
        MembershipStatusRunReportFor: TRunReportFor;
        SecondDropdown: string;
        UseTerminationDate?: any;
        MembershipStatusSortReportBy: TSortReportByValues;
        MembershipStatusStartDate: Date;
        MembershipStatusEndDate: Date;
        ExcludeCurrentMembers?: boolean;
        selectedPreset: {
            name: string;
            status: number;
        };
        minDate: Date;
    }

    interface IPreset {
        name: string,
        status: PresetStatus
    }

    type TRunReportFor = 'AboutToExpire' | 'Cancelled' | 'Expired' | 'Frozen' | 'Suspended';
    type TSortReportByValues = 'Cancellation Reason' | 'Membership' | 'Client Name' | 'Expiration Date';

    const defaultSortReportBy = [
        { label: 'LABEL_MEMBERSHIP', value: 'Membership' },
        { label: 'LABEL_CLIENT_NAME', value: 'Client Name' },
        { label: 'LABEL_CANCELLATION_REASON', value: 'Cancellation Reason' },
    ];
    const expiredSortReportBy = [
        { label: 'LABEL_CLIENT_NAME', value: 'Client Name' },
        { label: 'LABEL_EXPIRATION_DATE', value: 'Expiration Date' },
        { label: 'LABEL_MEMBERSHIP', value: 'Membership' },
    ];
    const ABOUT_EXPIRE_PRESET_LIST = [
        { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
        { name: 'LABEL_TODAY', status: PresetStatus.Today },
        { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
        { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
        { name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter },
        { name: 'LABEL_NEXT_QUARTER', status: PresetStatus.NextQuarter },
        { name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear },
        { name: 'LABEL_TOMORROW', status: PresetStatus.Tomorrow },
        { name: 'LABEL_NEXT_WEEK', status: PresetStatus.NextWeek },
        { name: 'LABEL_NEXT_MONTH', status: PresetStatus.NextMonth },
        { name: 'LABEL_NEXT_YEAR', status: PresetStatus.NextYear }
    ];

    const DEFAULT_PRESET_LIST = Meevo.Components.Controls.DEFAULT_PRESET_LIST;

    class MeevoReportDb015Component implements angular.IComponentController {

        static $inject = [
            '$translate'
        ];

        public mainModel: IDB015Model;
        public parameterNames: string[];
        public securityAccess: any;
        public options: IOptions;
        public validationJson: ICurrentValidationJson;

        public reportForData: IValue[];
        public customPreset: Boolean = true;

        public sortByData = defaultSortReportBy;
        public presetList: Array<IPreset>;

        public frozenData = [
            { label: 'LABEL_CURRENT_FROZEN_MEMBERS', value: 'Current Frozen Members' },
            { label: 'LABEL_FROZEN_FEE_COLLECTED', value: 'Frozen Fee Collected' }
        ];

        set runReportForValue(value: TRunReportFor | null) {
            if (this.mainModel != null) {
                if (value === 'Suspended' || value === 'Frozen' || this.mainModel.MembershipStatusRunReportFor === 'Frozen') {
                    this.mainModel.MembershipStatusStartDate = new Date();
                    this.mainModel.MembershipStatusEndDate = new Date();
                    this.customPreset = !this.customPreset;
                }

                if (value === 'AboutToExpire') {
                    this.presetList = ABOUT_EXPIRE_PRESET_LIST;
                    this.validationJson.RunReportFor = 'FutureToday';
                    
                } else {
                    this.presetList = DEFAULT_PRESET_LIST;
                    this.validationJson.RunReportFor = 'All'
                }

                this.mainModel.MembershipStatusRunReportFor = value;

                if (value !== 'Cancelled' && this.sortReportByCancellationReasonSelected) {
                    this.mainModel.MembershipStatusSortReportBy = 'Membership';
                }

                if (value !== 'Frozen') {
                    this.mainModel.SecondDropdown = this.frozenData[0].value;
                }

                if (value !== 'Cancelled') {
                    this.mainModel.UseTerminationDate = null;
                }

                if (value === 'Expired') {
                    this.sortByData = expiredSortReportBy;
                    this.mainModel.MembershipStatusSortReportBy = 'Client Name';
                    this.mainModel.ExcludeCurrentMembers = false;
                } else {
                    this.mainModel.ExcludeCurrentMembers = null;
                    this.sortByData = defaultSortReportBy;
                }
            }
        }

        get runReportForValue(): TRunReportFor | null {
            if (this.mainModel)
                return this.mainModel.MembershipStatusRunReportFor;
            else
                return null;
        }

        set runReportForFrozenValue(value: string) {
            this.mainModel.SecondDropdown = value;

            if (value === this.frozenData[0].value) {
                this.mainModel.MembershipStatusStartDate = new Date();
                this.mainModel.MembershipStatusEndDate = new Date();
            } else {
                this.mainModel.MembershipStatusStartDate = moment().add(-6, 'days').endOf('day').toDate();
                this.mainModel.MembershipStatusEndDate = new Date();
            }
        }

        get runReportForFrozenValue() {
            if (this.mainModel)
                return this.mainModel.SecondDropdown;
            else
                return null;
        }

        get sortReportByCancellationReasonSelected(): boolean {
            if (this.mainModel != null && this.mainModel.MembershipStatusSortReportBy != null) {
                return this.mainModel.MembershipStatusSortReportBy === 'Cancellation Reason';
            } else {
                return false;
            }
        }

      get dateControlShow(): boolean {
            if (this.mainModel != null && this.mainModel.MembershipStatusRunReportFor != null) {
                return this.mainModel.MembershipStatusRunReportFor === 'Cancelled'
                    || (
                        this.mainModel.MembershipStatusRunReportFor === 'Frozen'
                        && this.mainModel.SecondDropdown === this.frozenData[1].value
                    )
                    || this.mainModel.MembershipStatusRunReportFor === 'Expired'
                    ;
            } else {
              return false;
            }
        }

        get showMembershipTerminationDate(): boolean {
            if (this.mainModel != null && this.mainModel.MembershipStatusRunReportFor != null)
                return this.mainModel.MembershipStatusRunReportFor === 'Cancelled';
            else
                return false;
        }

        get isRunForCanceled(): boolean {
            if (this.mainModel != null && this.mainModel.MembershipStatusRunReportFor != null)
                return this.mainModel.MembershipStatusRunReportFor === 'Cancelled';
            else
                return false;
        }

        $onInit() {
            this.reportForData = this.options.values;

            //todo delete this parameter name
            this.parameterNames[4] = 'SecondDropdown';
        }
    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportDb015Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/db015/meevo-report-db015.component.html',
            controller: MeevoReportDb015Component,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                validationJson: '<',
                options: '<',
                disabled: '=?ngDisabled'
            }
        });
}
